import { toastError, toastSuccess } from '@components/Toast';

import * as actionTypes from '@store/orders/action-types';

import ApiClient from '@lib/apiClient';

export const fetchDefaultQuotes = (ids) => async (dispatch) => {
	try {
		const response = await ApiClient.POST('createOrder', ids);
		dispatch({
			type: actionTypes.FETCH_DEFAULT_QUOTES_SUCCESS,
			payload: response.data.map((item) => {
				return {
					...item,
					buyerQuotationType: 'DESIGNWISE',
					sizeWiseBuyerPrice: {},
					colorWiseBuyerPrice: {},
					priceType: '',
					poNumber: '',
					deliveryDate: '',
					referenceNumber: item?.productReferenceNumber || ''
				};
			})
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_DEFAULT_QUOTES_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const addPantoneColorToProduct = (productId, colorId) => async (dispatch) => {
	try {
		const response = await ApiClient.POST('addPantoneColorToProduct', {}, `${productId}/${colorId}`);
		dispatch({ type: actionTypes.ADD_COLOR_TO_PRODUCT_SUCCESS, payload: response.data });
		if (response.status === 200) {
			toastSuccess(response.data.message);
			return response.data;
		}
	} catch (error) {
		dispatch({ type: actionTypes.ADD_COLOR_TO_PRODUCT_FAILURE });
		if (error?.response.message) {
			toastError(error.response.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const addSizeToProduct = (productId, sizeCode, unitType) => async (dispatch) => {
	try {
		const response = await ApiClient.POST('addSizeToProduct', {
			measurementUnit: unitType,
			productId: productId,
			size: sizeCode
		});
		dispatch({ type: actionTypes.ADD_SIZE_TO_PRODUCT_SUCCESS, payload: response.data });
		if (response.status === 200) {
			if (response.data.message) toastSuccess(response.data.message);
			else toastSuccess('Size added successfully');
		}
	} catch (error) {
		dispatch({ type: actionTypes.ADD_SIZE_TO_PRODUCT_FAILURE });
		if (error?.response.message) {
			toastError(error.response.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchInvoiceDetails = (id) => async (dispatch) => {
	try {
		const response = await ApiClient.GET('invoiceAction', id);
		dispatch({
			type: actionTypes.FETCH_PI_DETAILS_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_PI_DETAILS_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchBrandLocaionList = (id) => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getBrandLocaionList', id);
		dispatch({
			type: actionTypes.FETCH_BRAND_LOCATION_LIST_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_BRAND_LOCATION_LIST_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchBeneficiaryList = () => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getBeneficiaryList');
		dispatch({
			type: actionTypes.FETCH_BENEFICIARY_ALL_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_BENEFICIARY_ALL_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchNitexBankDetails = () => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getNitexBankDetails');
		dispatch({
			type: actionTypes.FETCH_NITEX_BANK_DETAILS_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_NITEX_BANK_DETAILS_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchOrderPlaceWorkflow = (id) => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getOrderPlacementStatus', id);
		dispatch({
			type: actionTypes.FETCH_ORDER_PLACE_WORKFLOW_SUCCESS,
			payload: response.data
		});
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_ORDER_PLACE_WORKFLOW_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchOrderDetailsInfo = (orderId) => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getOrderDetails', orderId);
		dispatch({
			type: actionTypes.FETCH_ORDER_DETAILS_INFO_SUCCESS,
			payload: response.data
		});
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_ORDER_DETAILS_INFO_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchAllUsersByTypes = () => async (dispatch) => {
	try {
		let params = '?userTypes=MERCHANDISER&userTypes=QA';
		const response = await ApiClient.GET('getUsersByTypes', params);
		dispatch({
			type: actionTypes.FETCH_ALL_USERS_BY_TYPES_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_ALL_USERS_BY_TYPES_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};
